var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 7.24992V15.8333C16.6668 17.6666 15.1668 19.1666 13.3335 19.1666H6.66683C4.8335 19.1666 3.3335 17.6666 3.3335 15.8333V4.16658C3.3335 2.33325 4.8335 0.833252 6.66683 0.833252H10.2502C11.1668 0.833252 12.0002 1.16658 12.5835 1.83325L15.6668 4.91658C16.3335 5.49991 16.6668 6.33325 16.6668 7.24992Z",
    stroke: "#414446",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 7.49992H11.6667C10.75 7.49992 10 6.74992 10 5.83325V0.833252",
    stroke: "#414446",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/Reports.86988ca74d4b8aec657a17f9bdd06d60.svg";
export { ForwardRef as ReactComponent };